import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import * as API from "../../api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faTrash } from "@fortawesome/free-solid-svg-icons";
import { UploadDownload } from "../UploadDownload";

export const ModuleTareaDocsReserva = ({
  data = [],
  metadata = [],
  requestAdd,
  requestDelete,
  refreshDocs,
  setLoading,
  access,
  title = "Documentos de la Reserva",
}) => {
  const puedeEliminar = typeof requestDelete === "function" && access?.Editar;
  return (
    <S.Wrapper>
      <S.Header>
        <p>{title}</p>
        {requestAdd && (
          <S.DivButton onClick={requestAdd} disabled={!access?.Editar}>
            <FontAwesomeIcon icon={faFileLines} size="lg" />
          </S.DivButton>
        )}
      </S.Header>
      <S.Content>
        <table>
          <thead>
            <S.TrColumnTitles>
              {metadata.map((e) => (
                <th key={e.name}>{e.label}</th>
              ))}
              {puedeEliminar && (
                <th aria-label="Acciones" style={{ width: "1%", textAlign: "center" }}></th>
              )}
            </S.TrColumnTitles>
          </thead>
          <tbody>
            {data.map((document) => (
              <tr key={document.id}>
                {metadata.map((field) => (
                  <td key={field.name}>
                    {field.type === undefined && document[field.name]}
                    {field.type === "file" && (
                      <UploadDownload
                        id={document.id}
                        nombreDocumento={document[field.name]}
                        uploadEnabled={true}
                        uploadService={API.actualizarDocumentoReserva}
                        uploadSuccess={refreshDocs}
                        setLoading={setLoading}
                      />
                    )}
                  </td>
                ))}
                {puedeEliminar && (
                  <td style={{ width: "1%", textAlign: "center" }}>
                    <S.DeleteButton
                      type="button"
                      onClick={() => requestDelete(document)}
                      title="Eliminar documento"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </S.DeleteButton>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </S.Content>
    </S.Wrapper>
  );
};

ModuleTareaDocsReserva.propTypes = {
  data: PropTypes.array,
  metadata: PropTypes.array,
  requestAdd: PropTypes.func,
  requestDelete: PropTypes.func,
  refreshDocs: PropTypes.func,
  setLoading: PropTypes.func,
  access: PropTypes.object,
  title: PropTypes.string,
};
